import { render, staticRenderFns } from "./DeleteMediaPopup.vue?vue&type=template&id=93f88834&scoped=true&"
import script from "./DeleteMediaPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteMediaPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteMediaPopup.vue?vue&type=style&index=0&id=93f88834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f88834",
  null
  
)

export default component.exports